import { render, staticRenderFns } from "./SmsTemplates.vue?vue&type=template&id=104c1f10&scoped=true&"
import script from "./SmsTemplates.vue?vue&type=script&lang=js&"
export * from "./SmsTemplates.vue?vue&type=script&lang=js&"
import style0 from "./SmsTemplates.vue?vue&type=style&index=0&id=104c1f10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104c1f10",
  null
  
)

export default component.exports